package one.healthium.onboarding.domain.models


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SelectableOption(
    @SerialName("key") val key: String,
    @SerialName("text") val text: GenderText,
    @SerialName("alt_text") val altText: String? = null,
    @SerialName("additional_selected_text") val additionalSelectedText: String? = null,
)